module.exports = __webpack_public_path__ + "static/media/app-store-badge.6fc6b941.png";